// src/components/popups/RoleInfoDrawer.js
import React from 'react';
import './RoleInfoDrawer.css';

function RoleInfoDrawer({ isOpen, role, onClose }) {
  if (!isOpen) return null;

  const normalizedRole = String(role || 'pioneer').toLowerCase();

  const getTitle = () => {
    if (normalizedRole === 'admin') return 'What is an Admin?';
    if (normalizedRole === 'app') return 'What is an App Account?';
    if (normalizedRole === 'merchant') return 'What is a Merchant?';
    return 'What is a Pioneer?';
  };

  const getDescription = () => {
    if (normalizedRole === 'admin') {
      return (
        <>
          An <strong>Admin</strong> is a trusted BarterFi platform account responsible for helping manage and protect the ecosystem.
          <br /><br />
          Admins may help with:
          <ul>
            <li>Moderation and safety</li>
            <li>Community support</li>
            <li>Reviewing reports and platform activity</li>
            <li>Keeping BarterFi secure and organized</li>
          </ul>
          Admin accounts are official platform roles and are not regular marketplace seller accounts by default.
        </>
      );
    }

    if (normalizedRole === 'app') {
      return (
        <>
          An <strong>App Account</strong> is a verified account representing a Pi ecosystem application on BarterFi.
          <br /><br />
          App Accounts can be used to:
          <ul>
            <li>Post updates and announcements</li>
            <li>Build followers and community presence</li>
            <li>Engage directly with Pioneers</li>
            <li>Represent an app with a verified identity</li>
          </ul>
          App Accounts are linked to a registered app identity and help users clearly distinguish apps from normal personal accounts.
        </>
      );
    }

    if (normalizedRole === 'merchant') {
      return (
        <>
          A <strong>Merchant</strong> is a verified seller on BarterFi who can list products and services in the marketplace.
          <br /><br />
          Merchants have access to:
          <ul>
            <li>Escrow-secured transactions</li>
            <li>Customizable store profiles</li>
            <li>Product promotion tools</li>
            <li>Direct engagement with customers</li>
            <li><strong>Dynamic pricing</strong> to protect against Pi price fluctuations</li>
          </ul>
          Only approved users who pay the monthly merchant fee can sell as merchants.
        </>
      );
    }

    return (
      <>
        A <strong>Pioneer</strong> is a regular user on BarterFi who can explore the platform, create posts, tip others, and interact with merchants.
        <br /><br />
        Pioneers can:
        <ul>
          <li>Browse the marketplace</li>
          <li>Follow and message merchants</li>
          <li>Participate in the Pi-based social feed</li>
        </ul>
        To sell products or services, a Pioneer must apply to become a Merchant.
      </>
    );
  };

  return (
    <div className="roleinfo-overlay">
      <div className="roleinfo-popup">
        <div className="roleinfo-header">
          <h3>{getTitle()}</h3>
        </div>
        <div className="roleinfo-body">
          <p>{getDescription()}</p>
        </div>
        <div className="roleinfo-footer">
          <button className="roleinfo-close-btn" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default RoleInfoDrawer;
